import React from 'react';
import { 
  Authenticator, 
  ThemeProvider, 
  View, 
  Heading, 
  useTheme, 
  Text,
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

const formFields = {
  signIn: {
    username: {
      placeholder: 'Enter your username',
      isRequired: true,
      label: 'Username',
    },
    password: {
      placeholder: 'Enter your password',
      isRequired: true,
      label: 'Password',
    },
  },
};

// Custom theme that matches your app's dark theme
const theme = {
  name: 'dark-theme',
  tokens: {
    colors: {
      background: {
        primary: '#131313',
        secondary: '#191919',
      },
      brand: {
        primary: {
          10: '#131313',
          20: '#191919',
          40: '#303030',
          60: '#404040',
          80: '#505050',
          90: '#606060',
          100: '#707070',
        },
      },
      font: {
        interactive: '#bbbbbb',
        primary: '#bbbbbb',
        secondary: '#777777',
        error: '#d32f2f',
      },
      border: {
        primary: '#404040',
        secondary: '#303030',
        tertiary: '#252525',
      },
    },
    components: {
      authenticator: {
        router: {
          borderWidth: '0',
        },
      },
      button: {
        primary: {
          backgroundColor: '#303030',
          color: '#bbbbbb',
          borderRadius: '6px',
          _hover: {
            backgroundColor: '#404040',
          },
          _active: {
            backgroundColor: '#505050',
          },
        },
      },
      fieldcontrol: {
        borderWidth: '1px',
        borderColor: '#404040',
        borderRadius: '6px',
        color: '#bbbbbb',
      },
      tabs: {
        item: {
          borderColor: '#404040',
          color: '#777777',
          _hover: {
            color: '#bbbbbb',
          },
          _active: {
            color: '#bbbbbb',
            borderColor: '#bbbbbb',
          },
        },
      },
    },
  },
};

export const LoginScreen: React.FC = () => {
  return (
    <div className="login-container" style={{marginTop: "10%"}}>
      <ThemeProvider theme={theme}>
        <Authenticator
          formFields={formFields}
          loginMechanisms={['username']}
          hideSignUp={true}
          socialProviders={[]}
        >
          {() => (
            <div>
              <h1>Logged In</h1>
            </div>
          )}
        </Authenticator>
      </ThemeProvider>
    </div>
  );
};